import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAccountProjectsQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
  page: Types.PageInput;
  projectStatus?: Types.InputMaybe<Array<Types.ProjectStatusInput>>;
  workspaceIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']>>;
  accountUserIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']>>;
  storageTypes?: Types.InputMaybe<Array<Types.MountedStorageStatus>>;
  query?: Types.InputMaybe<Types.Scalars['String']['input']>;
  orders?: Types.InputMaybe<Array<Types.ProjectOrderInput>>;
  cheap?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  mountedStorageActivityDays: Types.Scalars['Int']['input'];
}>;


export type GetAccountProjectsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, projects: { __typename?: 'ProjectConnection', totalCount?: number, nodes: Array<{ __typename?: 'Project', id: string, archivedAt?: string | null, deletedAt?: string | null, description?: string | null, fileCount: number, ignoreArchive: boolean, insertedAt: string, isWorkfront?: boolean | null, lastUpdated: string, name: string, mountedStorageStatus?: Types.MountedStorageStatus | null, private: boolean, storage: number, updatedAt?: string | null, images: { __typename?: 'Images', image64?: string | null }, mountedStorageActivity?: { __typename?: 'MountedStorageActivitySummary', recentUserCount?: number | null, lastActivityAt?: string | null } | null, workspace?: { __typename?: 'Workspace', id: string, accountId?: string | null, name: string, images?: { __typename?: 'Images', image64?: string | null } | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } } | null };


export const GetAccountProjects = /*#__PURE__*/ gql`
    query GetAccountProjects($accountId: ID!, $page: PageInput!, $projectStatus: [ProjectStatusInput!], $workspaceIds: [ID!], $accountUserIds: [ID!], $storageTypes: [MountedStorageStatus!], $query: String, $orders: [ProjectOrderInput!], $cheap: Boolean = false, $mountedStorageActivityDays: Int!) {
  account(accountId: $accountId) {
    id
    projects(
      page: $page
      filter: {projectStatus: $projectStatus, storageTypes: $storageTypes, query: $query, workspaceIds: $workspaceIds, accountUserIds: $accountUserIds}
      orders: $orders
    ) {
      nodes {
        id
        archivedAt
        deletedAt
        description
        fileCount
        ignoreArchive
        images {
          image64
        }
        insertedAt
        isWorkfront
        lastUpdated
        name
        mountedStorageStatus
        mountedStorageActivity(days: $mountedStorageActivityDays) {
          recentUserCount
          lastActivityAt
        }
        private
        storage
        updatedAt
        workspace {
          id
          accountId
          name
          images {
            image64
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount @skip(if: $cheap)
    }
  }
}
    ` as unknown as DocumentNode<GetAccountProjectsQuery, GetAccountProjectsQueryVariables>;

          

          export const useGetAccountProjectsQuery = (options?:QueryHookOptions<GetAccountProjectsQuery, GetAccountProjectsQueryVariables>) => useQuery(GetAccountProjects, options);

          

          export type GetAccountProjectsQueryOptions = QueryHookOptions<GetAccountProjectsQuery, GetAccountProjectsQueryVariables>;

          

          export const useGetAccountProjectsLazyQuery = (options?:LazyQueryHookOptions<GetAccountProjectsQuery, GetAccountProjectsQueryVariables>) => useLazyQuery(GetAccountProjects, options);

          

          export type GetAccountProjectsQueryResult = ReturnType<typeof useGetAccountProjectsQuery>;

          
